<template>
    
    <detalhe titulo="Objeto Integração" :size="size">
        <vue-json-pretty
            :data="JSON.parse(atendimento?.objetoIntegracaoConsultaIntegracao)"
            :showDoubleQuotes="true"
            v-if="atendimento?.objetoIntegracaoConsultaIntegracao && atendimento?.objetoIntegracaoConsultaIntegracao?.isJson()"
        ></vue-json-pretty>
        
    </detalhe>
    <detalhe titulo="Retorno Integração" :size="size">
        <vue-json-pretty
            :data="JSON.parse(atendimento?.objetoRetornoConsultaIntegracao)"
            :showDoubleQuotes="true"
            v-if="atendimento?.objetoRetornoConsultaIntegracao && atendimento?.objetoRetornoConsultaIntegracao?.isJson()"
        ></vue-json-pretty>
        <span v-if="atendimento?.objetoRetornoConsultaIntegracao && !atendimento?.objetoRetornoConsultaIntegracao?.isJson()">
            {{ atendimento?.objetoRetornoConsultaIntegracao }}</span
        >
    </detalhe>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    components: {
        VueJsonPretty,
    },

    props: {
        atendimento: {
            type: Object,
        },
    },

    data() {
        return {
            size: '140',
        };
    },
};
</script>
